import React from 'react';
import VolumeWidgetBuilder from './VolumeWidgetBuilder';
import VolumeWidgetRenderer from './VolumeWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { VolumeWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartColumn } from '@fortawesome/free-solid-svg-icons';

export { default as VolumeWidgetBuilder } from './VolumeWidgetBuilder';
export { default as VolumeWidgetRenderer } from './VolumeWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'volume',
  meta: {
    label: 'Volume',
    icon: React.createElement(FontAwesomeIcon, { icon: faChartColumn }),
    description: 'Historical volume chart with ADTV from market data',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'PRICE',
    // No horizon param: the fetch returns the full history and the widget's
    // range pills trim client-side (same pattern as the Price widget).
    params: [
      { key: 'adtv_window', label: 'ADTV Window', defaultValue: 63, unit: 'trading days', type: 'number', placeholder: '63' },
    ],
  },
  defaultSize: { w: 8, h: 5, minW: 4, minH: 3 },
  defaultConfig: () => ({ defaultRange: '3M' } as VolumeWidgetConfig),
  Builder: VolumeWidgetBuilder,
  Renderer: VolumeWidgetRenderer,
  Preview,
};
